'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/Button';
import { Section } from '@/components/ui/Section';
import { Container } from '@/components/ui/Container';
import styles from './CtaSection.module.css';

interface CtaSectionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonUrl: string;
  ctaId: string;
  ctaPosition: string;
}

export default function CtaSection({
  title,
  description,
  buttonText,
  buttonUrl,
  ctaId,
  ctaPosition
}: CtaSectionProps) {
  return (
    <Section background="primary" className={styles.ctaSection}>
      <Container size="md">
        <div className={styles.cta}>
          <h2 className={styles.ctaTitle}>{title}</h2>
          <p className={styles.ctaDescription}>{description}</p>
          <Link href={buttonUrl}>
            <Button 
              variant="primary" 
              size="lg"
              data-cta-id={ctaId}
              data-cta-position={ctaPosition}
              data-cta-variant="primary"
            >
              {buttonText}
            </Button>
          </Link>
        </div>
      </Container>
    </Section>
  );
}

